import '../layouts/default';

import { checkResolution } from '../functions/helpers'
import { updateLazy } from '../functions/lazy';
import { scrollToEl } from '../common/anchor';
import { initCountdowns } from '../functions/countdown';

import '../ui/more-items'
import '../ui/shorten';

import './catalog-jquery'

const attachPaginatorEvents = () => {
    for (const pagerButton of document.querySelectorAll('.pager__list .c-btn')) {
        if (pagerButton.classList.contains('is-active')) continue

        pagerButton.addEventListener('click', (event) => {
            scrollToEl(document.querySelector('.l-catalog-products') || document.querySelector('.listing'), (checkResolution('cxs;xs') ? 0 : 40))
        })
    }
}

attachPaginatorEvents()

rEvent.on('Listing.fetchedData', () => {
    updateLazy()
    attachPaginatorEvents()

    if ($('.js-pager-current-count').length) {
        $('.js-pager-current-count').html($('.listing.products').first().find('.products__item').length);
    }
})

document.addEventListener('DOMContentLoaded', function() {
    if (document.querySelector('.js-countdown')) {
        initCountdowns();
    }
});

var filterElem = document.getElementById("filter");

if (filterElem !== null) {
    filterElem.addEventListener("category.changed", function (e) {
        const categoryId = e.detail.category_id;
        const filterCategoryIdInput = document.getElementById('filterCategoryId');

        if (filterCategoryIdInput) {
            filterCategoryIdInput.value = categoryId;
        }
        Filter.submit();
    });
}